'use client';
import HeaderVariety from '../shared/header-variety';
import NavCard from './_NavCard';

const NavCards = ({ _meta, navCards, title, headerVariation, _testID }) => {
  const footerCards = _meta?.schema?.indexOf('footer') >= 0;
  return (
    <div
      className={`tw-py-16 ${footerCards ? '' : 'rotating-background'} ${
        footerCards
          ? 'tw-bg-gradient-to-b tw-from-white tw-from-25% tw-via-white tw-via-75% tw-to-neutral-900 tw-to-75%'
          : ''
      }`}
      data-test-id={`nav_cards_${_testID}`}
    >
      <div className="tw-container tw-mx-auto">
        {title && (
          <div className="tw-mb-6 md:tw-mb-8 tw-text-center">
            <HeaderVariety defaultVariation="h2" headerVariation={headerVariation?.headerVariation}>
              {title}
            </HeaderVariety>
          </div>
        )}
        <ul className="tw-flex tw-flex-col md:tw-flex-row tw-list-none">
          {navCards.map((card, i) => (
            <NavCard key={i} {...card} />
          ))}
        </ul>
      </div>
    </div>
  );
};

export default NavCards;
